import { BookkeepingTagNavItemValue } from '../types/bookkeepingTagNavItemValue'

export const isBookkeepingTagValid = (bookkeepingTag: BookkeepingTagNavItemValue) =>
  Boolean(bookkeepingTag?.tag && bookkeepingTag?.response)
